module.exports = __webpack_public_path__ + "img/Cover_FS_17.125e8764.jpg";